import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        data: {
            seo: {
                title: 'Agence immobilière à Tahiti et en Polynésie | Manava',
                description: 'Achetez, vendez, louez ou faites estimer un bien à Tahiti et en Polynésie française avec l’accompagnement local de Manava Immobilier.',
                path: '/',
                image: '/assets/img/cover/moorea-island.webp',
                breadcrumbs: [{ name: 'Accueil', path: '/' }]
            }
        },
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
    },
    {
        path: 'properties', children: [
            {
                path: '',
                data: {
                    seo: {
                        title: 'Biens immobiliers à vendre et à louer à Tahiti | Manava',
                        description: 'Découvrez nos maisons, appartements, terrains et locaux à vendre ou à louer à Tahiti et dans les îles de Polynésie française.',
                        path: '/properties',
                        image: '/assets/img/cover/house-real-estate-3.webp',
                        breadcrumbs: [
                            { name: 'Accueil', path: '/' },
                            { name: 'Biens immobiliers', path: '/properties' }
                        ]
                    }
                },
                loadComponent: () => import('./pages/property-list/property-list.component').then(m => m.PropertyListComponent)
            },
            {
                path: ':name',
                data: {
                    seo: {
                        title: 'Bien immobilier en Polynésie française | Manava',
                        description: 'Consultez les photos, le prix et les caractéristiques de ce bien immobilier proposé par Manava Immobilier.',
                        path: '/properties',
                        robots: 'index, follow, max-image-preview:large'
                    }
                },
                loadComponent: () => import('./pages/property-detail/property-detail.component').then(m => m.PropertyDetailComponent)
            }
        ]
    },
    {
        path: 'services',
        data: {
            seo: {
                title: 'Vente, location et estimation immobilière à Tahiti | Manava',
                description: 'Manava Immobilier vous accompagne pour acheter, vendre, louer ou estimer votre bien à Tahiti et en Polynésie française.',
                path: '/services',
                image: '/assets/img/agent-holding-keys-home.webp',
                breadcrumbs: [
                    { name: 'Accueil', path: '/' },
                    { name: 'Services immobiliers', path: '/services' }
                ]
            }
        },
        loadComponent: () => import('./pages/service/service.component').then(m => m.ServiceComponent)
    },
    {
        path: 'contact',
        data: {
            seo: {
                title: 'Contacter Manava Immobilier à Tahiti',
                description: 'Échangez avec notre agence immobilière en Polynésie française pour votre projet d’achat, de vente, de location ou d’estimation.',
                path: '/contact',
                image: '/assets/img/profile-tevainui-landscape.webp',
                breadcrumbs: [
                    { name: 'Accueil', path: '/' },
                    { name: 'Contact', path: '/contact' }
                ]
            }
        },
        loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
    },
    {
        path: 'legal-notice',
        data: {
            seo: {
                title: 'Mentions légales | Manava Immobilier',
                description: 'Consultez les mentions légales, les informations sur l’éditeur et la politique de protection des données de Manava Immobilier.',
                path: '/legal-notice',
                breadcrumbs: [
                    { name: 'Accueil', path: '/' },
                    { name: 'Mentions légales', path: '/legal-notice' }
                ]
            }
        },
        loadComponent: () => import('./pages/legal-notice/legal-notice.component').then(m => m.LegalNoticeComponent)
    },
    { path: '**', redirectTo: '' }
];
